import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AccessibilityWidget } from "./components/AccessibilityWidget";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import ContactPage from "./pages/ContactPage";
import BookCallPage from "./pages/BookCallPage";
import AccessibilityPage from "./pages/AccessibilityPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/book-call" element={<BookCallPage />} />
            <Route path="/website-accessibility" element={<AccessibilityPage />} />
            {/* Placeholder routes for legal pages */}
            <Route path="/terms" element={<HomePage />} />
            <Route path="/privacy" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
        <AccessibilityWidget />
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
